import React, { useState, useEffect } from "react";
import axios from "axios";
import { TextField } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import "react-phone-input-2/lib/style.css";
import styles from "./index.module.css";
import { getLocation } from "../../utils/ipAddress";
import { validateEmail } from "../../utils/helper";
import ShareReferral from "../ShareReferral";

const REACT_APP_URL = process.env.REACT_APP_URL;

const ReferralForm = ({ onSubmitted, referralCode, parentId }) => {
  const [formData, setFormData] = useState({
    leadName: "",
    contact: "",
    email: "",
  });
  const [countryCode, setCountryCode] = useState("us");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dialCode, setDialCode] = useState(null);

  useEffect(() => {
    const loadCountry = async () => {
      await getLocation(setCountryCode, () => {});
    };
    loadCountry();
  }, []);

  const submitReferral = async (payload) => {
    try {
      const { data } = await axios.post(
        `${REACT_APP_URL}/saveReferralDetails`,
        payload,
      );

      if (!data?.success) {
          toast.error(
            "Error While Submitting Request, Please Try Again Later",
            { position: toast.POSITION.TOP_RIGHT },
          );
        setIsSubmitting(false);
        return;
      }

      toast.success(
        "Referral request submitted! We will contact your friend shortly",
        { position: toast.POSITION.TOP_RIGHT },
      );
      setFormData({
        leadName: "",
        contact: `+${dialCode}`,
        email: "",
      });
      if (onSubmitted) {
        onSubmitted();
      }
      setIsSubmitting(false);
    } catch (error) {
      const errData = error?.response?.data;
      if (errData?.isReferralExist) {
        toast.error(errData.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(errData.msg || "Error While Submitting Request, Please Try Again Later", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.leadName.trim()) {
      return toast.error("Please enter your friend's name", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    if (formData.contact.length < 10) {
      return toast.error("Please enter a valid phone number", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    if (!formData.email.trim()) {
      return toast.error("Please enter your friend's email", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    if (!validateEmail(formData.email)) {
      return toast.error("Please enter a valid email address", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    const payload = {
      leadName: formData.leadName,
      contact: formData.contact,
      email: formData.email,
      parentId,
    };

    setIsSubmitting(true);
    await submitReferral(payload);
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handlePhoneChange = (phone, countryData) => {
    handleChange("contact", phone);
    if (countryData?.dialCode) {
      setDialCode(countryData.dialCode);
    }
  };

  return (
    <div className={styles.formContainer}>
      <h2 className={styles.formTitle}>Refer your friends and family</h2>

      <form onSubmit={handleSubmit}>
        <div className={styles.fieldGroup}>
          <TextField
            fullWidth
            placeholder="Enter your friend's name"
            value={formData.leadName}
            onChange={(e) => handleChange("leadName", e.target.value)}
            className={styles.textField}
          />
        </div>

        <div className={styles.fieldGroup}>
          <div className={styles.phoneInputWrapper}>
            <PhoneInput
              country={countryCode?.toLowerCase() || "us"}
              value={formData.contact}
              onChange={handlePhoneChange}
              countryCodeEditable={false}
              enableSearch
              searchPlaceholder="Search country"
              inputProps={{
                name: "contact",
                required: true,
              }}
              containerClass={styles.phoneContainer}
              inputClass={styles.phoneInput}
              buttonClass={styles.phoneButton}
            />
            {!formData.contact && (
              <span className={styles.phonePlaceholder}>
                Enter contact number
              </span>
            )}
          </div>
        </div>

        <div className={styles.fieldGroup}>
          <TextField
            fullWidth
            placeholder="Enter your friend’s email ID"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
            type="email"
            className={styles.textField}
          />
        </div>

        <button
          type="submit"
          className={styles.submitButton}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>

      <div className={styles.referralDividerContainer}>
        <div className={styles.referralDivider} />
        <span className={styles.referralDividerText}>or</span>
        <div className={styles.referralDivider} />
      </div>
      
      <ShareReferral referralCode={referralCode} />
    </div>
  );
};


export default ReferralForm;